<template>
  <colgroup :class="`v-table-wrapper-colgroup`">
    <col v-for="(column, index) in scope.props.headers"
         :key="index"
         :class="`v-table-wrapper-col-${index}`"
         :width="cols[index]">
  </colgroup>
</template>

<script>
  import {store} from '../store'

  export default {
    name: 'VColgroup',
    props: {
      scope: Object,
      state: String
    },
    data: () => ({
      unwatchList: [],
      cols: {},
      from: null,
      type: null
    }),
    methods: {
      setTableWidth(width) {
        if (this.from === 'header')
          store.commit(this.type === 'common' ? 'setCommonWidth' : 'setFixedWidth', width)
      }
    },
    computed: {
      lastColDef() {
        return store.state.lastColDef
      }
    },
    watch: {
      lastColDef: {
        handler(v) {
          if (this.$el.children[v.index] && v.width)
            this.cols[v.index] = v.width
        }
      }
    },
    created() {
      const tmp = this.state.split(' ')
      this.from = tmp[0]
      this.type = tmp[1]

      let {headers} = this.scope.props

      for (let index = 0; index < headers.length; index++) {
        this.$set(this.cols, index, headers[index].width || null)
      }
    },
    mounted() {
      const ELEMENT = this.$el.parentElement
      ELEMENT.removeChild(ELEMENT.children[0])

      let {headers} = this.scope.props

      this.$nextTick(() => {
        let widthTable = 0
        for (let index = 0; index < headers.length; index++) {
          let width = store.state.colgroup[index]
          widthTable += width
          this.cols[index] = width
        }
        this.setTableWidth(widthTable)
      })

    }
  }
</script>

<style scoped>

</style>
